import type { SkillDef } from "../../engine/rpg/Skills";

export const SKILLS: SkillDef[] = [
  {
    id: "spark",
    name: "Spark",
    mp: 2,
    kind: "damage",
    target: "enemy",
    power: 12,
    ignoresDefense: true,
    color: 0x9fd8ff,
    sound: "spell",
    description: "A lance of cold light. Ignores armour.",
  },
  {
    id: "firestorm",
    name: "Firestorm",
    mp: 6,
    kind: "damage",
    target: "all-enemies",
    power: 14,
    variance: 0.25,
    ignoresDefense: true,
    color: 0xff8a3a,
    sound: "spell",
    description: "Flame washes over every enemy.",
  },
  {
    id: "mend",
    name: "Mend",
    mp: 3,
    kind: "heal",
    target: "ally",
    power: 26,
    field: true,
    color: 0x7dff9b,
    sound: "heal",
    description: "Closes wounds. Usable any time.",
  },
  {
    id: "greater-mend",
    name: "Greater Mend",
    mp: 7,
    kind: "heal",
    target: "all-allies",
    power: 34,
    field: true,
    color: 0x7dff9b,
    sound: "heal",
    description: "Mends the whole party at once.",
  },
  {
    id: "lullaby",
    name: "Lullaby",
    mp: 4,
    kind: "status",
    target: "enemy",
    status: "sleep",
    statusChance: 0.6,
    statusTurns: 3,
    color: 0xc39bff,
    sound: "spell",
    description: "Sings an enemy to sleep.",
  },
  {
    id: "revive",
    name: "Revive",
    mp: 10,
    kind: "revive",
    target: "ally",
    power: 0.5,
    field: true,
    color: 0xfff2a0,
    sound: "heal",
    description: "Calls a fallen friend back, at half strength.",
  },

  // ---- monster-only skills -------------------------------------------------
  {
    id: "monster-bite",
    name: "Savage Bite",
    mp: 0,
    kind: "damage",
    target: "enemy",
    power: 11,
    color: 0xff6b6b,
    sound: "hit",
    castMessage: (user) => `${user} lunges with a savage bite!`,
  },
  {
    id: "monster-flame",
    name: "Ember Breath",
    mp: 3,
    kind: "damage",
    target: "all-enemies",
    power: 13,
    ignoresDefense: true,
    color: 0xff8a3a,
    sound: "spell",
    castMessage: (user) => `${user} breathes a gout of flame!`,
  },
  {
    id: "monster-drain",
    name: "Drain",
    mp: 2,
    kind: "damage",
    target: "enemy",
    power: 9,
    ignoresDefense: true,
    color: 0xb06bff,
    sound: "spell",
    castMessage: (user) => `${user} drinks deeply of your strength!`,
  },
  {
    id: "monster-mend",
    name: "Knit Bones",
    mp: 3,
    kind: "heal",
    target: "ally",
    power: 20,
    color: 0x7dff9b,
    sound: "heal",
    castMessage: (user) => `${user} knits itself back together!`,
  },
];
